// extracted by mini-css-extract-plugin
export var tosLink = "_4d-0";